// extracted by mini-css-extract-plugin
export default {"block":"role_block__a2k0R","item":"role_item__pg--3","checked":"role_checked__wXDmC","icon":"role_icon__YYO+z","desc":"role_desc__RmWK9","actions":"role_actions__pwQSZ"};